var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRangeIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1367_1254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2997 5.91032L12.2424 4.96765L15.5424 8.26765L12.2424 11.5677L11.2997 10.625L13.6564 8.26765L11.2997 5.91032ZM4.6997 5.91032L2.34303 8.26765L4.6997 10.625L3.75703 11.5677L0.457031 8.26765L3.75703 4.96765L4.6997 5.91032Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1367_1254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.267639)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRangeIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/RangeIcon.cebef9f9.svg";
export { ForwardRef as ReactComponent };